import Axios from 'axios';
import Qs from 'qs';

export default {
	//厂商列表
	listPage(
		type,
		name,
		contacts,
		page,
		limit
	) {
		return Axios.get('/deviceManage/api/admin/mill-factory', {
			params: {
				type,
				name,
				contacts,
				page,
				limit
			},
			paramsSerializer(params) {
				return Qs.stringify(params);
			}
		});
	},
	add(
		//需要新增的数据（数据名称）
		type,
		name,
		address,
		contacts,
		mobile,
		permit_image,
	) {
		return Axios.post('/deviceManage/api/admin/mill-factory/add', {
			//和上面新增的数据相同
			type,
			name,
			address,
			contacts,
			mobile,
			permit_image,
		})
	},
	//修改厂商
	edit(
		id,
		type,
		name,
		address,
		contacts,
		mobile,
		permit_image,
	) {
		return Axios.patch(`device-management/mill-factory/${id}`, {
			//和上面数据相同
			type,
			name,
			address,
			contacts,
			mobile,
			permit_image,
		})
	},
	//厂商详情
	info(
		id
	) {
		return Axios.get(`/deviceManage/api/admin/mill-factory/${id}`);
	},
	//删除厂商
	del(
		//获取id
		id
	) {
		return Axios.delete(`/deviceManage/api/admin/mill-factory/${id}`, {
			//需要删除的内容
			data: {
				ids: [id]
			}
		})
	},


}